/* eslint-disable no-param-reassign */
import { createActionTypeReducer } from 'util/reducers'
import { buildId } from 'util/globalId'
import {
  queryIdToQuery,
  queryStringToQueryId,
  normalizeSearchQueryId,
} from 'ducks/searches/utils'
import { CHAT_PAGE } from 'subapps/chat/pages'
import { BUILD_FROM_WIDGETS } from '../actionTypes/collections'
import { SET_ITEMS_BYID } from '../actionTypes/items'

const itemsByIdInitialState = {}

export const itemsById = createActionTypeReducer(
  {
    [SET_ITEMS_BYID]: (_, { payload: { items = [] } }) => {
      return items.reduce((itemById, item) => {
        itemById[item.id] = item
        return itemById
      }, {})
    },
    [BUILD_FROM_WIDGETS]: (
      draftState,
      { payload: { widgets = [], folders = [] } }
    ) => {
      widgets.forEach(widget => {
        let { id: widgetId } = widget
        widgetId = buildId('Widget', widgetId)
        folders.forEach(folder => {
          const {
            id: folderId,
            position,
            displayCountWhenInactive,
            queryId,
            name,
          } = folder
          const itemId = `${widgetId}_${folderId}`
          const itemQueryId = normalizeSearchQueryId(
            `channel:${widgetId} type:widget ${queryId}`
          )
          if (!draftState[itemId]) {
            draftState[itemId] = {
              id: itemId,
              name,
              groupId: null,
              collectionId: widgetId,
              position,
              displayCountWhenInactive,
              queryId: itemQueryId,
              linkTo: {
                type: CHAT_PAGE,
                payload: {
                  query: queryIdToQuery(itemQueryId),
                },
              },
            }
          }
        })
      })
      return draftState
    },
  },
  itemsByIdInitialState
)

const currentQueryIdFromQueryReducer = (_, action) => {
  // https://github.com/faceyspacey/redux-first-router/blob/master/docs/query-strings.md#where-query-lives-on-your-actions
  const { meta: { location: { current: { query = {} } = {} } = {} } = {} } =
    action || {}
  return queryStringToQueryId(query)
}

export const currentQueryId = createActionTypeReducer(
  {
    [CHAT_PAGE]: currentQueryIdFromQueryReducer,
    [BUILD_FROM_WIDGETS]: draftState => {
      if (!draftState) {
        return 'unassigned'
      }
      return draftState
    },
  },
  null
)
